// extracted by mini-css-extract-plugin
export default {"drawerModeBreakpoint":"1040px","longCardBreakpoint":"580px"};